<script>
/**
 * Features component
 */
export default {
  name: "Features"
};
</script>

<template>
  <!--START FEATURES-->
  <section class="section" id="features">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-box mt-5 mt-lg-0">
            <h3>
              A digital web design studio creating modern & attractive websites
            </h3>
            <p class="text-muted web-desc">
              Our team is ready to propose ideas, design and build your personal
              website, e-commerce, blog or even your portfolio.
            </p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li class>Pick your style from several designs</li>
              <li class>
                Be unique by letting us design your own look based on your
                business
              </li>
              <li class>
                Choose between WordPress or a tailor made content management
                system for your dynamic site.
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-img mx-auto mr-lg-0">
            <img
              src="@/assets/images/websites.svg"
              alt="macbook image"
              class="img-fluid"
            />
          </div>
        </div>
      </div>

      <div class="row align-items-center mt-lg-5">
        <div class="col-lg-5 order-2 order-lg-2">
          <div class="features-box mt-5 mt-lg-0">
            <h3>
              Your web application runs perfectly on your mobile device
            </h3>
            <p class="text-muted web-desc">
              We build beautiful Single Page Apps or Progressive Web Apps with
              responsive design that almost feel like native apps.
            </p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li class>Web applications (SPA, PWA)</li>
              <li class>
                Windows / Mac applications
              </li>
              <li class>Native iOS / Android applications</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-1">
          <div class="features-img mx-auto ml-lg-0">
            <img
              src="@/assets/images/webapps.svg"
              alt="macbook image"
              class="img-fluid"
            />
          </div>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-lg-5 order-2 order-lg-1 mt-lg-5">
          <div class="features-box mt-5 mt-lg-0">
            <h3>
              Stream your event with extraordinary video and audio quality
            </h3>
            <p class="text-muted web-desc">
              We mix your live event and stream it on your website or directly
              on your favorite streaming service with broadcast quality.
            </p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li class>Private HD streams on website</li>
              <li class>
                Public HD streams on Youtube, Facebook, Twitch
              </li>
              <li class>Interactive HD Streams with Skype & Zoom</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-img mx-auto mr-lg-0">
            <img
              src="@/assets/images/stream.svg"
              alt="macbook image"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END FEATURES-->
</template>